import React, { createContext, useContext, useState, useCallback } from 'react';

const SchemaContext = createContext();

export const SchemaProvider = ({ children }) => {
  const [additionalSchemas, setAdditionalSchemas] = useState([]);
  const [isHydrated, setIsHydrated] = useState(false);

  // Track hydration status
  React.useEffect(() => {
    setIsHydrated(true);
  }, []);

  const addSchema = useCallback((schema) => {
    if (schema && isHydrated) {
      setAdditionalSchemas(prev => {
        // Avoid duplicates
        if (prev.some(existing => JSON.stringify(existing) === JSON.stringify(schema))) {
          return prev;
        }
        return [...prev, schema];
      });
    }
  }, [isHydrated]);

  const clearSchemas = useCallback(() => {
    if (isHydrated) {
      setAdditionalSchemas([]);
    }
  }, [isHydrated]);

  return (
    <SchemaContext.Provider value={{ additionalSchemas: isHydrated ? additionalSchemas : [], addSchema, clearSchemas }}>
      {children}
    </SchemaContext.Provider>
  );
};

export const useSchema = () => {
  const context = useContext(SchemaContext);
  if (!context) {
    throw new Error('useSchema must be used within a SchemaProvider');
  }
  return context;
};

// Hook for components to register their schemas
export const useRegisterSchema = (schemaData) => {
  const { addSchema } = useSchema();
  
  React.useEffect(() => {
    if (schemaData) {
      addSchema(schemaData);
    }
  }, [schemaData, addSchema]);
};